import loadImage from './loadImage';
import preloadImages from './preloadImages';

export default {
  loadImage,
  preloadImages,
};



// WEBPACK FOOTER //
// ../src/components/core/images/index.js